<template>
  <Teleport to="body">
    <Transition name="paywall">
      <div v-if="authStore.showPaywall" class="fixed inset-0 z-[120] flex items-end justify-center" @click.self="close">
        <!-- Backdrop -->
        <div class="absolute inset-0 bg-black/40" @click="close" />

        <!-- Bottom sheet -->
        <div class="relative w-full max-w-[430px] bg-cream rounded-t-3xl px-6 pt-6 pb-sheet-8 z-10">
          <!-- Close button -->
          <button @click="close" class="absolute top-4 right-4 p-1">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2.5" stroke-linecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>

          <!-- Icon -->
          <div class="flex justify-center mb-4">
            <div class="w-14 h-14 rounded-full bg-ink/10 flex items-center justify-center">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
            </div>
          </div>

          <!-- Вариант B (services/sales.js): в iOS-сборке продаж нет, поэтому
               ни цен, ни «оформите подписку», ни перехода на тарифы — гайдлайн
               App Store 3.1.1. Премиум — свойство аккаунта. -->
          <template v-if="iosSalesDisabled">
            <h2 class="text-xl font-bold text-center text-ink mb-2">Пробный период закончился</h2>
            <p class="text-sm text-center text-ink/70 mb-6 leading-relaxed">
              ИИ-функции Зои сейчас недоступны.<br>
              Дневник и записи работают как раньше.
            </p>
            <button
              @click="close"
              class="w-full py-3 rounded-xl text-sm font-medium text-white bg-ink active:bg-[#2a1a10] transition-colors"
            >
              Понятно
            </button>
          </template>

          <template v-else>
            <h2 class="text-xl font-bold text-center text-ink mb-2">Нужна подписка</h2>
            <p class="text-sm text-center text-ink/70 mb-6 leading-relaxed">
              Бесплатный пробный период закончился.<br>
              Для доступа к ИИ-функциям Зои оформите подписку.
            </p>

            <!-- Buttons -->
            <div class="flex gap-3">
              <button
                @click="close"
                class="flex-1 py-3 rounded-xl text-sm font-medium text-ink bg-ink/10 active:bg-ink/20 transition-colors"
              >
                Назад
              </button>
              <button
                @click="goToSubscription"
                class="flex-1 py-3 rounded-xl text-sm font-medium text-white bg-ink active:bg-[#2a1a10] transition-colors"
              >
                Выбрать тариф
              </button>
            </div>
          </template>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { watch, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../store/auth.js'
import { track } from '../analytics.js'
import { reportPaywallEvent } from '../services/paywallEvents.js'
import { iosSalesDisabled } from '../services/sales.js'

const authStore = useAuthStore()
const router = useRouter()

let savedScrollY = 0

// Блокировка скролла фона при открытии
watch(() => authStore.showPaywall, (val) => {
  if (val) {
    reportPaywallEvent('subscription', 'shown')
    track('paywall_popup_shown')
    savedScrollY = window.scrollY
    document.body.style.position = 'fixed'
    document.body.style.top = `-${savedScrollY}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.overflow = ''
    window.scrollTo(0, savedScrollY)
  }
})

onUnmounted(() => {
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.overflow = ''
})

function close() {
  reportPaywallEvent('subscription', 'close')
  authStore.showPaywall = false
}

function goToSubscription() {
  reportPaywallEvent('subscription', 'cta')
  authStore.showPaywall = false
  router.push('/subscription')
}
</script>

<style scoped>
.paywall-enter-active,
.paywall-leave-active {
  transition: opacity 0.3s ease;
}
.paywall-enter-active .relative,
.paywall-leave-active .relative {
  transition: transform 0.3s ease;
}
.paywall-enter-from,
.paywall-leave-to {
  opacity: 0;
}
.paywall-enter-from .relative {
  transform: translateY(100%);
}
.paywall-leave-to .relative {
  transform: translateY(100%);
}
</style>
